import imageOne from "./assets/images/assets-bbb.webp";

export const config = {
  title: "LENNYQ Construction LLC | Columbus, OH",
  meta: {
    description:
      "LENNYQ Construction LLC - Family-owned and operated licensed professionals with over 25 years of experience. Kitchen & bathroom remodeling, flooring, painting, drywall, carpentry, roofing, and more in Columbus, OH.",
    keywords: [
      "LENNYQ Construction LLC",
      "General Contractor Columbus OH",
      "Kitchen Remodeling",
      "Bathroom Remodeling",
      "Flooring Installation",
      "Painting Services",
      "Drywall",
      "Carpentry Work",
      "Roofing Repair",
      "Power Washing"
    ],
    author: "LENNYQ Construction LLC",
    canonicalUrl: "https://lennyqconstruction.com/",
  },
  sections: {
    header: {
      businessName: "LENNYQ Construction LLC",
    },
    sectionB: {
      heroTitle: "Trusted Remodeling & General Contractor",
      heroSubtitle: "Family-Owned, Licensed Professionals with Over 25 Years of Experience",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "3017920668",
      phoneLabel: "(301) 792-0668",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2076&auto=format&fit=crop",
      cardData: [
        {
          title: "Kitchen & Bathroom",
          description:
            "Expert kitchen and bathroom remodeling services that transform your spaces into functional and beautiful areas.",
        },
        {
          title: "Flooring & Painting",
          description:
            "Professional flooring installation and painting services to refresh and enhance your property.",
        },
        {
          title: "Carpentry & Roofing",
          description:
            "Skilled carpentry work and roofing repair to ensure structural integrity and lasting quality.",
        },
      ],
      description:
        "LENNYQ Construction LLC is a family-owned and operated business serving communities with licensed, bonded, and insured professional services. With over 25 years of experience, we deliver exceptional quality in every project.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive remodeling and construction services for residential and commercial properties. Licensed, bonded, and insured for your peace of mind.",
      cards: [
        {
          title: "Kitchen & Bathroom Remodeling",
          description:
            "Complete kitchen and bathroom renovations with expert design, quality materials, and professional installation for stunning results.",
          imageSrc: "https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Kitchen and Bathroom Remodeling",
        },
        {
          title: "Flooring & Painting",
          description:
            "Professional flooring installation and painting services including interior and exterior work for homes and businesses.",
          imageSrc: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=2074&auto=format&fit=crop",
          imageAlt: "Flooring and Painting Services",
        },
        {
          title: "Carpentry & Roofing",
          description:
            "Expert carpentry work, custom woodwork, and roofing repair services to enhance and protect your property.",
          imageSrc: "https://media.istockphoto.com/id/134253640/photo/construction-of-a-wooden-roof-frame-underway.jpg?s=612x612&w=0&k=20&c=e5gUkic9LGQWahIdHozOsEzHKy_HtsmvmtOHmYsejSU=",
          imageAlt: "Carpentry and Roofing Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Drywall Installation & Repair",
        "Power Washing",
        "Stonework & Granite",
        "Gutter Cleaning",
        "Shed Building",
      ],
    },
    sectionD: {
      aboutTitle: "About LENNYQ Construction LLC",
      aboutImage: {
        src: imageOne,
        alt: "LENNYQ Construction Team",
      },
      aboutText: [
        "LENNYQ Construction LLC is a family-owned and operated business with over 25 years of experience serving residential and commercial clients. As licensed, bonded, and insured professionals, we take pride in delivering exceptional quality and craftsmanship on every project.",
        "Our comprehensive services include kitchen and bathroom remodeling, flooring, painting, drywall, carpentry work, roofing repair, stonework, power washing, and more. We treat every property with care and respect, ensuring projects are completed on time, within budget, and to the highest standards. Our commitment to customer satisfaction has made us a trusted name in the community.",
      ],
    },
    sectionE: {
      profileImage: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/o8ONAnd80Js1OpqzwOrQ/media/66e46d703025a7e22ed1ef02.png",
      profileAlt: "LENNYQ Construction LLC",
      businessName: "LENNYQ Construction LLC",
      contact: {
        phone: "3017920668",
        phoneLabel: "(301) 792-0668",
        email: "lennyqconstructionllc@gmail.com",
        website: "https://lennyqconstruction.com/",
        address: "3757 N High St, Columbus, OH 43214",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "3757 N High St, Columbus, OH 43214",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3056.2!2d-83.0068!3d40.0389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388e8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s3757%20N%20High%20St%2C%20Columbus%2C%20OH%2043214!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;